"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.intro.start': 'Iniciar Onboarding',
    'onboarding.intro.optimize': 'Optimizar Operaciones y Procesos',
    'onboarding.intro.moment': 'Ha llegado el momento de la implementación estratégica de Asistentes IA avanzados.',
    'onboarding.intro.enables': 'Su uso en la empresa permite:',
};
